import { useId, useState, type InputHTMLAttributes } from 'react';

function PasswordVisibilityIcon({ visible }: { visible: boolean }) {
  return (
    <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
      <path d="M2.75 12S6.15 6.75 12 6.75 21.25 12 21.25 12 17.85 17.25 12 17.25 2.75 12 2.75 12Z" />
      <circle cx="12" cy="12" r="2.4" />
      {visible ? <path d="m4.25 4.25 15.5 15.5" /> : null}
    </svg>
  );
}

export function PasswordInput({
  disabled,
  id,
  ...inputProps
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const generatedId = useId();
  const [visible, setVisible] = useState(false);
  const inputId = id ?? generatedId;
  const toggleLabel = visible ? 'Hide password' : 'Show password';

  return (
    <span className="password-input">
      <input
        {...inputProps}
        autoCapitalize="none"
        disabled={disabled}
        id={inputId}
        spellCheck={false}
        type={visible ? 'text' : 'password'}
      />
      <button
        aria-controls={inputId}
        aria-label={toggleLabel}
        aria-pressed={visible}
        className="password-visibility-toggle"
        disabled={disabled}
        title={toggleLabel}
        type="button"
        onClick={() => setVisible((current) => !current)}
        onMouseDown={(event) => event.preventDefault()}
      >
        <PasswordVisibilityIcon visible={visible} />
      </button>
    </span>
  );
}
